import { DropdownData } from '@zayan-erp/shared';

export enum ClosingScheme {
  Freehold = 1,
  Potl = 2,
  Condominium = 3
}

export enum ClosingType {
  Tentative = 0,
  Firm = 1
}

export enum CriticalDateType {
  FirstTentative = 1,
  SecondTentative = 2,
  Firm = 3,
  Delayed = 4,
  SubsequentTentative = 5,
  FinalTentative = 6,
  Outside = 7
}

export const CRITICAL_DATES_ADDENDUM_REQUIRED = 'criticalDatesAddendumRequired';

export interface CriticalDates {
  id: string;
  lotId?: string;
  dealId?: string;
  closingType: number;
  closingScheme: ClosingScheme;
  roofAssemblyDate: string | null;
  isFinalTentative: boolean;
  addendums: LotCriticalDateAddendum[];
  firstTentativeActualDate: string | null;
  firstTentativeProjectedDate: string | null;
  firstTentativeNoticeDueDate: string | null;
  firstTentativeNoticeSentDate: string | null;
  firstTentativeNoticeMethod: string | null;
  secondTentativeActualDate: string | null;
  secondTentativeProjectedDate: string | null;
  secondTentativeNoticeDueDate: string | null;
  secondTentativeNoticeSentDate: string | null;
  secondTentativeNoticeMethod: string | null;
  firmActualDate: string | null;
  firmProjectedDate: string | null;
  firmNoticeDueDate: string | null;
  firmNoticeSentDate: string | null;
  firmNoticeMethod: string | null;
  delayedActualDate: string | null;
  delayedProjectedDate: string | null;
  buyerTerminationActualDate: string | null;
  buyerTerminationProjectedDate: string | null;
  createdAt: string;
  lastModified: string | null;
  createdByUserId: string;
  updatedByUserId: string | null;
}

export interface LotCriticalDateAddendum {
  id: string;
  addendumNo: number;
  addendumDate: string;
  criticalDateType: CriticalDateType;
  originalDate: string | null;
  adjustedDate: string;
  reasonCodeId: string;
  reasonCode: number;
  reasonCodeName: string | null;
  memo: string | null;
  noticeSentDate: string | null;
  createdAt: string;
  createdByUserName: string | null;
}

export interface CriticalDateAddendumRequest {
  reasonCodeId: string;
  memo?: string | null;
  addendumDate?: string | null;
}

export interface CriticalDateChange {
  type: CriticalDateType;
  originalDate: string | null;
  adjustedDate: string;
}

export interface CriticalDatesAddendumRequired {
  changes: CriticalDateChange[];
  warnings: string[];
}

export interface CriticalDateReasonCode {
  id: string;
  code: number;
  name: string;
  sortOrder: number;
}

export interface CreateCriticalDates {
  closingType: number;
  calculationDate: string | null;
  delayedActualDate: string | null;
  buyerTerminationActualDate: string | null;
  noticeSentDate: string | null;
  noticeMethod: string | null;
  outsideDate?: string | null;
  roofAssemblyDate?: string | null;
}

export interface UpdateFirstTentative {
  actualDate: string | null;
  delayedActualDate: string | null;
  buyerTerminationActualDate: string | null;
  firstTentativeNoticeSentDate: string | null;
  firstTentativeNoticeMethod: string | null;
  addendum?: CriticalDateAddendumRequest | null;
}

export interface UpdateSecondTentative {
  actualDate: string | null;
  delayedActualDate: string | null;
  buyerTerminationActualDate: string | null;
  secondTentativeNoticeSentDate: string | null;
  secondTentativeNoticeMethod: string | null;
  isFinalTentative?: boolean;
  addendum?: CriticalDateAddendumRequest | null;
}

export interface UpdateFirm {
  actualDate: string | null;
  delayedActualDate: string | null;
  buyerTerminationActualDate: string | null;
  firmNoticeSentDate: string | null;
  firmNoticeMethod: string | null;
  addendum?: CriticalDateAddendumRequest | null;
}

export interface UpdateOccupancyTerms {
  outsideDate: string;
  roofAssemblyDate: string | null;
  addendum?: CriticalDateAddendumRequest | null;
}

export interface CriticalDatesFinalTentativeDue {
  roofAssemblyDate: string;
  finalTentativeOrFirmDueDate: string;
}

export const CLOSING_TYPES: DropdownData[] = [
  {
    id: '0',
    firstLabel: 'Tentative',
    secondLabel: 'Tentative'
  },
  {
    id: '1',
    firstLabel: 'Firm',
    secondLabel: 'Firm'
  }
];
